import { __assign, __extends } from "tslib";
// DS: I95
import React from 'react';
import IconWrap from '../IconWrap';
var Emote = /** @class */ (function (_super) {
    __extends(Emote, _super);
    function Emote() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Emote.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
                React.createElement("defs", null,
                    React.createElement("path", { id: "emotei95a", d: "M20 4v16H4V4h16zm-2 2H6v12h12V6zm-3.12 8c-.278 1.141-1.489 2-2.94 2-1.451 0-2.662-.859-2.94-2h5.88zM9.5 9c.828 0 1.5.672 1.5 1.5S10.328 12 9.5 12 8 11.328 8 10.5 8.672 9 9.5 9zm5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z" })),
                React.createElement("g", { fill: "none", fillRule: "evenodd" },
                    React.createElement("mask", { id: "emotei95b", fill: "#fff" },
                        React.createElement("use", { href: "#emotei95a" })),
                    React.createElement("use", { fill: "currentColor", href: "#emotei95a" }),
                    React.createElement("g", { mask: "url(#emotei95b)" },
                        React.createElement("path", { d: "M0 0h24v24H0z" }))))));
    };
    return Emote;
}(React.Component));
export { Emote };
export default Emote;
//# sourceMappingURL=Emote.js.map